export default __webpack_public_path__ + "static/media/852hz-awaken-intuition.8704f8a6.mp3";